import { TALENT_DROPDOWN_VALUES } from 'ui-components/dist/TalentDropdown';
import { create } from 'zustand';
import { Platform } from '~/screens/MyAgency/types';

type MyAgencyStore = {
  rosterType: TALENT_DROPDOWN_VALUES.agency | TALENT_DROPDOWN_VALUES.self;
  setRosterType: (rosterType: MyAgencyStore['rosterType']) => void;

  isAdvancedFiltersDrawerOpen: boolean;
  setIsAdvancedFiltersDrawerOpen: (isOpen: boolean) => void;

  advancedFiltersActivePlatform: Platform;
  setAdvancedFiltersActivePlatform: (platform: Platform) => void;
};

export const useMyAgencyStore = create<MyAgencyStore>((set) => ({
  rosterType: TALENT_DROPDOWN_VALUES.agency,
  setRosterType: (rosterType) => set(() => ({ rosterType })),

  isAdvancedFiltersDrawerOpen: false,
  setIsAdvancedFiltersDrawerOpen: (isOpen) =>
    set(() => ({ isAdvancedFiltersDrawerOpen: isOpen })),

  advancedFiltersActivePlatform: 'Select Platform' as Platform,
  setAdvancedFiltersActivePlatform: (platform) =>
    set(() => ({ advancedFiltersActivePlatform: platform })),
}));
